import { FormatMixin, DotnetMixin } from './mixins/index.js';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createRouter, createWebHistory } from 'vue-router';
import './plugins/axios';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { routes } from './routing/index.js';
import { useAuthStore } from './stores/index.js';
import '../styles/main.css';
import './plugins/validation';
import { installToast } from './services/toast.service.js';
import { installDialog } from './services/dialog.service.js';

import DDatePicker from '@components/DDatePicker.vue';
import { Calendar, DatePicker, setupCalendar } from 'v-calendar';
import 'v-calendar/style.css';

library.add(fad);

// Create Vue app
const app = createApp({});

// Create Pinia store
const pinia = createPinia();

// Create router
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Add global mixins
app.mixin(DotnetMixin);
app.mixin(FormatMixin);

// Install plugins
app.use(pinia);
app.use(router);
app.use(installToast);
app.use(installDialog);
app.use(setupCalendar, {
  firstDayOfWeek: 1,  // Setting Sunday (1) as the first day of week globally
});

// Register external components globally
app.component('v-calendar', Calendar);
app.component('v-date-picker', DatePicker);
app.component('font-awesome-icon', FontAwesomeIcon);

// Register custom components globally
app.component('d-datepicker', DDatePicker);

// Helper function to convert PascalCase to kebab-case
function toKebabCase(str) {
  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .toLowerCase();
}

// Import all components globally
const modules = import.meta.glob(['./components/**/*.vue', '/Views/**/*.vue'], { eager: true });
Object.entries(modules).forEach(([path, module]) => {
  try {
    const component = module.default;
    if (!component) return;

    const name = path.split('/').pop().split('.')[0];
    const kebabName = toKebabCase(name);
    app.component(kebabName, component);
  } catch (error) {
    console.error('Error importing module:', path, module, error);
    return;
  }
});

// Wait for CSS to load before mounting
window.addEventListener('load', () => {
  // Mount the app
  app.mount('#vue-wrapper');

  setTimeout(() => {
    // Remove loading cover
    const elem = document.getElementById('loadCover');
    if (elem) {
      elem.parentNode.removeChild(elem);
    }
  }, 250);
});

// Setup user data in auth store
const authStore = useAuthStore();
// Initialize the auth store automatically
authStore.initialize();